<template>
  <div class="bttn" @click="open">{{$t('vue2.createuser_button.create_user')}}</div>
</template>

<script>
  import eventbus from '../../../eventbus'
  export default {
    methods: {
      open () {
        eventbus.createUserModal = true
        eventbus.createUserModalROR = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CreateUserButtonROR.vue?7123b25d